<template>
  <div>
    <loading :active.sync="isLoading"></loading>
    <div id="attribution-node"></div>
    <div class="banner-image default-banner-image" v-if="!bannerImageUrl" v-bind:style="bannerImageUrl">
      <div class="container-fluid">
        <div class="row h-100">
          <div v-if="getUserType !== 'business' && !isClaimed" class="col text-center my-auto">
            <h1 class="title">Is this your business?</h1>
            <h3 class="title">Update your info and connect with customers</h3>
            <div class="container">
              <div class="row">
                <div class="col-md-4 offset-md-4">
                  <button class="btn btn-primary" v-on:click="preClaim()">Claim It Now!</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="banner-image valid-banner-image" v-if="bannerImageUrl" v-bind:style="bannerImageUrl"></div>
    <div id="sub-bar" class="container-fluid">
      <div class="row">
        <div class="col-3">
          <img id="business-public-profile-pic" v-show="profileImageUrl" v-bind:src="profileImageUrl" alt="prof pic" class="profile-image">
        </div>
        <div class="col-md-5 my-auto">
          <h3 id="business-title" class="d-inline-block no-margin">{{ businessName }}</h3>
        </div>
        <div class="col-md-4 my-auto star-selector">
          <stars class="stars" :rating="starRating"></stars>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col offset-md-3">
          <h5 v-on:click="replaceRoute('information')"
            v-bind:class="{underline: '/business/' + businessId + '/' + isGoogle + '/information' === currentPath }"
            class="subnav-item d-inline-block">Information</h5>
          <h5 v-on:click="replaceRoute('reviews')"
            v-bind:class="{underline: '/business/' + businessId + '/' + isGoogle + '/reviews' === currentPath }"
            class="subnav-item d-inline-block">Reviews</h5>
          <h5 v-on:click="replaceRoute('photos')"
            v-bind:class="{underline: '/business/' + businessId + '/' + isGoogle + '/photos' === currentPath }"
            class="subnav-item d-inline-block">Photos</h5>
          <h5 v-if="couponAvailable"
            v-on:click="replaceRoute('coupons')"
            v-bind:class="{underline: '/business/' + businessId + '/' + isGoogle + '/coupons' === currentPath }"
            class="subnav-item d-inline-block">Coupons</h5>
        </div>
        <div class="col my-auto contact-icons">
          <a href="tel:" v-if="salesPhone">
            <p class="d-inline-block contact-icon">
              <i class="fa fa-mobile-alt" aria-hidden="true"></i> Phone
            </p>
          </a>
          <a v-if="website" v-bind:href="httpWebsite" target="_blank">
            <p class="d-inline-block contact-icon">
              <i class="fa fa-globe-americas" aria-hidden="true"></i> Website
            </p>
          </a>
          <a v-if="salesEmail" v-bind:href="emailString" target="_blank">
            <p class="d-inline-block contact-icon">
              <i class="far fa-envelope" aria-hidden="true"></i> Email
            </p>
          </a>
        </div>
      </div>
    </div>
    <hr>
    <div class="container">
      <div class="row">
        <div class="col-lg-4 second">
          <left-side v-on:select-photos="replaceRoute('photos')"
            v-bind:service-type="serviceType"
            v-bind:cost-level-prop="costLevel"
            v-bind:business-name="businessName"
            v-bind:availability-prop="availabilityLevel"
            v-bind:insured-prop="insuredAmount"
            v-bind:emergencies-prop="emergencies"
            v-bind:licensed-prop="licensed"
            v-bind:enable-quote-request="enableQuoteRequst"
            v-bind:images="images"></left-side>
        </div>
        <div v-bind:class="[ couponAvailable ? 'col-lg-6' : 'col-lg-8' ]">
          <div class="jumbotron">
            <information v-if="'/business/' + businessId + '/' + isGoogle + '/information' === currentPath"
              v-bind:selectedSpecialties="selectedSpecialties"
              v-bind:specialties="specialties"
              v-bind:hasAdvertisingPlan="hasAdvertisingPlan"
              v-bind:hideYears="hideYears"
              v-bind:hideLocation="hideAddress"
              v-bind:getYearsInService="yearEstablished"
              v-bind:getAddress="address1"
              v-bind:getAddressTwo="address2"
              v-bind:getCity="city"
              v-bind:getState="state"
              v-bind:getZip="zipCode"
              v-bind:getTimes="hours"
              v-bind:getCompanyInfo="aboutUs"
              v-bind:getCompanyInfoTwo="aboutUsTwo"
              v-bind:getSelectedServices="services"></information>
            <reviews v-if="'/business/' + businessId + '/' + isGoogle + '/reviews' === currentPath"
              v-bind:googleReviews="googleReviews"
              v-bind:businessId="businessId"></reviews>
            <photos v-if="'/business/' + businessId + '/' + isGoogle + '/photos' === currentPath"
              v-bind:getImageUrls="images"></photos>
            <coupons v-if="('/business/' + businessId + '/' + isGoogle + '/coupons' === currentPath) && couponAvailable"
              v-bind:businessId="businessId"
              v-bind:combosAllowed="couponCombosAllowed"
              v-bind:couponExpiration="couponExpiration"
              v-bind:couponId="couponId"
              v-bind:customerReuses="couponCustomerReuses"
              v-bind:details="couponDetails"
              v-bind:discountedPrice="couponDiscountedPrice"
              v-bind:listPrice="couponListPrice"
              v-bind:name="couponName"
              v-bind:numberAvailable="couponNumberAvailable"></coupons>
          </div>
        </div>
        <div v-bind:class="[ couponAvailable ? 'col-lg-2' : 'd-none' ]">
          <right-side v-on:view-coupons="replaceRoute('coupons')"
            v-bind:couponName="couponName"></right-side>
        </div>
      </div>
    </div>
    <b-modal id="confirmModal" ref="confirmModal" size="lg" hide-footer>
      <div slot="modal-header" class="w-100 justify-content-center share-modal-header">
        <h3>Claim Business</h3>
        <button v-on:click="hideConfirmModal" class="close d-inline" type="button" aria-label="Close">x</button>
      </div>
      <div class="container">
        <div class="row">
          <div class="col">
            <p>Are you sure you want to claim this business? This cannot be undone without contacting our support team.</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 second">
            <button v-on:click="hideConfirmModal" class="btn btn-secondary">Cancel</button>
          </div>
          <div class="col-md-6">
            <button v-on:click="claim()" class="btn btn-primary">Confirm</button>
          </div>
        </div>
      </div>
    </b-modal>
    <the-auth-modal ref="authModal"></the-auth-modal>
  </div>
</template>

<script>
import information from './subnavItems/Information.vue'
import reviews from './subnavItems/Reviews.vue'
import photos from './subnavItems/Photos.vue'
import coupons from './subnavItems/Coupons.vue'
import leftSide from './leftSide/LeftSide.vue'
import stars from './Stars.vue'
import GooglePlacesApi from '../../lib/googlePlacesApi.js'
import rightSide from './rightSide/RightSide.vue'
import router from '../../router/index.js'
import { mapGetters } from 'vuex'
import mixins from '../GlobalMixins.js'
import TheAuthModal from '../authentication/TheAuthModal.vue'
import Loading from 'vue-loading-overlay'

function addressDetail (addressComponents, detail) {
  for (var component in addressComponents) {
    if (addressComponents[component].types.includes(detail)) {
      return addressComponents[component].long_name
    }
  }
  return null
}

// TODO figure out license problem, its not there
// TODO figure out why ssn is getting passed
export default {
  metaInfo () {
    return {
      title: this.businessName,
      meta: [
        { vmid: 'description', content: this.aboutUsTwo }
      ]
    }
  },
  data () {
    return {
      isClaimed: true,
      isLoading: false,
      currentCenter: 'information',
      aboutUs: null,
      aboutUsTwo: null,
      address1: null,
      address2: null,
      adminFirstName: null,
      adminLastName: null,
      adminPhone: null,
      adminEmail: null,
      allowSendTexts: null,
      availabilityLevel: null,
      bannerImageUrl: null,
      businessName: null,
      city: null,
      costLevel: null,
      displayName: null,
      emergencies: null,
      enableQuoteRequst: null,
      hideAddress: null,
      hideYears: null,
      yearEstablished: null,
      hours: null,
      images: [],
      insuredAmount: null,
      prioritization: null,
      profileImageUrl: null,
      salesPhone: null,
      serviceArea: null,
      serviceType: [],
      services: null,
      state: null,
      website: null,
      zipCode: null,
      rating: null,
      homaptRating: null,
      licensed: false,
      googleReviews: null,
      salesEmail: null,
      // Coupon data
      couponAvailable: false,
      couponCombosAllowed: null,
      couponCustomerReuses: null,
      couponDetails: null,
      couponDiscountedPrice: null,
      couponExpiration: null,
      couponId: null,
      couponListPrice: null,
      couponName: null,
      couponNumberAvailable: null,
      hasAdvertisingPlan: null,
      specialties: [],
      selectedSpecialties: []
    }
  },
  components: {
    Loading,
    information,
    reviews,
    photos,
    leftSide,
    rightSide,
    stars,
    coupons,
    TheAuthModal
  },
  mixins: [mixins],
  methods: {
    showConfirmModal () {
      this.$refs.confirmModal.show()
    },
    hideConfirmModal () {
      this.$refs.confirmModal.hide()
    },
    preClaim () {
      if (!this.getIdProvider) {
        this.$refs.authModal.$refs.authModal.show()
        return
      }
      this.showConfirmModal()
    },
    async claim (index) {
      this.isLoading = true
      this.hideConfirmModal()
      try {
        if (await this.businessIsClaimed(this.businessId)) {
          return
        } else {
          await this.claimBusiness(this.businessId, this.attributionElement)
        }
      } catch (error) {
        console.log(error)
      }
      this.isLoading = false
    },
    async getCategories () {
      var client = this.$store.getters.getBusinessApigClientFactory
      var params = {}
      var pathTemplate = '/businesses/categories'
      var method = 'GET'
      var additionalParams = {}
      var body = {}
      try {
        var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.specialties = result.data.categories
      } catch (error) {
        console.log(error)
      }
    },
    async getCoupons () {
      var client = this.$store.getters.getCouponApigClientFactory
      var params = {
        business_id: this.businessId
      }
      var pathTemplate = '/businesses/{business_id}/coupons'
      var method = 'GET'
      var additionalParams = {
        queryParams: {
          primary_coupon: true
        }
      }
      var body = {}
      try {
        var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        var coupon = result.data.data[0]
        if (coupon) {
          this.couponAvailable = true
          this.couponCombosAllowed = coupon.combos_allowed
          this.couponCustomerReuses = coupon.customer_reuses
          this.couponDetails = coupon.details
          this.couponDiscountedPrice = coupon.discounted_price
          this.couponExpiration = coupon.coupon_expiration
          this.couponId = coupon.coupon_id
          this.couponListPrice = coupon.list_price
          this.couponName = coupon.name
          this.couponNumberAvailable = coupon.number_available
        }
      } catch (error) {
        console.log(error)
      }
    },
    replaceRoute (centerElement) {
      router.push('/business/' + this.businessId + '/' + this.isGoogle + '/' + centerElement)
    },
    async getBusinessData () {
      if (this.isGoogle) {
        this.getGoogleBusinessData()
      }
      if (!this.isGoogle) {
        this.getHomaptBusinessData()
        this.getGoogleReviews()
      }
    },
    async getGoogleReviews () {
      try {
        var businessDetails = await GooglePlacesApi.googleDetails(this.attributionElement, this.businessId)
        if (businessDetails.reviews) this.googleReviews = businessDetails.reviews
      } catch (error) {
        if (error !== 'INVALID_REQUEST') {
          console.log(error)
        }
      }
    },
    async getGoogleAverageRating () {
      try {
        var businessDetails = await GooglePlacesApi.googleDetails(this.attributionElement, this.businessId)
      } catch (error) {
        console.log(error)
      }
      if (businessDetails) {
        if (businessDetails.rating) this.rating = businessDetails.rating
      }
    },
    async getGoogleBusinessData () {
      var businessDetails = await GooglePlacesApi.googleDetails(this.attributionElement, this.businessId)
      if (businessDetails.photos) this.images = businessDetails.photos.map((photo) => photo.getUrl())
      if (businessDetails.reviews) this.googleReviews = businessDetails.reviews
      if (businessDetails.international_phone_number) this.salesPhone = businessDetails.international_phone_number
      if (businessDetails.website) this.website = businessDetails.website
      if (businessDetails.name) this.businessName = businessDetails.name
      if (businessDetails.rating) this.rating = businessDetails.rating
      if (businessDetails.address_components) {
        this.state = addressDetail(businessDetails.address_components, 'administrative_area_level_1')
        this.city = addressDetail(businessDetails.address_components, 'locality')
        this.address1 = addressDetail(businessDetails.address_components, 'street_number') && addressDetail(businessDetails.address_components, 'route')
          ? addressDetail(businessDetails.address_components, 'street_number') + ' ' + addressDetail(businessDetails.address_components, 'route')
          : null
        this.address2 = addressDetail(businessDetails.address_components, 'subpremise')
        this.zipCode = addressDetail(businessDetails.address_components, 'postal_code')
      }
      if (businessDetails.opening_hours) {
        var days = businessDetails.opening_hours.weekday_text
        this.hours = {}
        for (var day in days) {
          var timeArray = days[day].split(': ')
          this.hours[timeArray[0]] = { open: timeArray[1] }
        }
      }
    },
    async getHomaptBusinessData () {
      var client = this.$store.getters.getBusinessApigClientFactory
      var params = {id: this.businessId}
      var pathTemplate = '/publicbusinesses/{id}'
      var method = 'GET'
      var additionalParams = {}
      var body = {}
      try {
        var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        var baseUrl = 'https://s3.' + window.CONFIG.Region +
                      '.amazonaws.com/' + window.CONFIG.PhotoBucketName +
                      '/xsmall/' + this.businessId + '/'
        var baseUrlXlarge = 'https://s3.' + window.CONFIG.Region +
                      '.amazonaws.com/' + window.CONFIG.PhotoBucketName +
                      '/xlarge/' + this.businessId + '/'
        this.aboutUs = result.data.about_us
        this.aboutUsTwo = result.data.about_us_two
        this.address1 = result.data.address1
        this.address2 = result.data.address2
        this.adminEmail = result.data.admin_email
        this.salesEmail = result.data.sales_email
        this.adminFirstName = result.data.admin_first_name
        this.adminLastName = result.data.admin_last_name
        this.adminPhone = result.data.admin_phone
        this.allowSendTexts = result.data.allow_send_texts
        this.availabilityLevel = result.data.availability_level
        this.bannerImageUrl = 'background-image: url(' + baseUrlXlarge + result.data.banner_image + ')'
        this.businessName = result.data.display_name
        this.city = result.data.city
        this.costLevel = result.data.cost_level
        this.displayName = result.data.display_name
        this.emergencies = result.data.emergencies
        this.enableQuoteRequst = result.data.enable_quote_request
        this.hideAddress = result.data.hide_address
        this.hideYears = result.data.hide_years
        this.yearEstablished = result.data.year_established
        this.hours = result.data.hours ? JSON.parse(result.data.hours) : null
        this.images = result.data.images ? result.data.images.map(image => baseUrl + image) : null
        this.insuredAmount = result.data.insured_amount
        this.prioritization = result.data.prioritization
        this.profileImageUrl = result.data.profile_image ? baseUrl + result.data.profile_image : '/static/defaultprofile.png'
        this.salesPhone = result.data.sales_phone
        this.serviceArea = result.data.service_area
        this.serviceType = JSON.parse(result.data.service_type)
        this.services = result.data.categories
        this.state = result.data.state
        this.website = result.data.website
        this.zipCode = result.data.zip_code
        this.hasAdvertisingPlan = result.data.has_advertising_plan
        this.selectedSpecialties = result.data.specialties
        this.homaptRating = result.data.avg_rating
        result.data.license_number ? this.licensed = true : this.licensed = false
      } catch (error) {
        console.log(error)
      }
    },
    setProfilePicLoc () {
      if (!this.isGoogle) {
        var subBar = document.getElementById('sub-bar')
        if (subBar) {
          var boundingRect = subBar.getBoundingClientRect()
          var profilePic = document.getElementById('business-public-profile-pic')
          var picWidth = profilePic.offsetWidth
          if (picWidth === 0) picWidth = 300
          profilePic.style.height = picWidth + 'px'
          profilePic.style.top = (boundingRect.bottom - boundingRect.top) - picWidth + 'px'
        }
      }
    }
  },
  computed: {
    ...mapGetters('user', [
      'getUserType'
    ]),
    ...mapGetters([
      'getIdProvider',
      'getSecretAccessKey'
    ]),
    starRating () {
      return this.homaptRating > 0 ? this.homaptRating : this.rating
    },
    currentPath () {
      return this.$route.path
    },
    businessId () {
      return this.$route.params.id
    },
    emailString () {
      return 'mailto:' + this.salesEmail
    },
    httpWebsite () {
      var url
      if (!/^(f|ht)tps?:\/\//i.test(this.website)) {
        url = 'http://' + this.website
        return url
      } else {
        return this.website
      }
    },
    isGoogle () {
      if (this.$route.params.google === 'true') {
        return true
      } else {
        return false
      }
    }
  },
  async mounted () {
    this.attributionElement = document.getElementById('attribution-node')
    try {
      this.isClaimed = await this.businessIsClaimed(this.businessId)
    } catch (error) {
      console.log(error)
    }

    try {
      await this.getCategories()
    } catch (error) {
      console.log(error)
    }

    try {
      this.getBusinessData()
    } catch (error) {
      console.log(error)
    }

    try {
      if (this.getSecretAccessKey) this.getCoupons()
    } catch (error) {
      console.log(error)
    }

    try {
      this.getGoogleAverageRating()
    } catch (error) {
      console.log(error)
    }
    this.setProfilePicLoc()
    window.addEventListener('resize', this.setProfilePicLoc)
  }
}
</script>

<style scoped>
.btn-secondary {
  width: 100% !important;
}

.container-fluid {
  height: 100%
}

@media (max-width: 992px) {
  .second {
    -ms-flex-order: 2;
    order: 2;
  }
}

@media (min-width: 992px) {
  .stars {
    text-align: right
  }
  .contact-icons {
    text-align: right;
    padding-right: 3rem;
  }
}

.stars {
  padding-right: 2.3rem;
  padding-left: 1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.contact-icon {
  padding-left: .5rem !important;
  padding-right: .5rem !important;
  padding-top: .5rem;
  padding-bottom: .5rem;
  margin-bottom: 0;
}

.title {
  color: white !important;
}
.contact-span {
  margin-top: .5rem;
}

.container {
  max-width: 1600px;
}

.banner-image {
  height: 30vh;
  background-size: cover;
  background-position: center;
}

.test {
  height: 10000px;
}

hr {
  border-width: 3px;
  margin-top: 0px;
}

.subnav-item {
  padding-top: .1rem;
  padding-bottom: .1rem;
  margin-right: 1rem;
  margin-left: 1rem;
  margin-top: .5rem;
  cursor: pointer;
}

#sub-bar {
  background-color: rgb(52, 58, 64);
}

#business-title {
  padding: 1rem;
  color: white !important;
}

.jumbotron {
  background-color: #f1f1f1 !important;
  border-radius: 25px;
  margin-bottom: 1rem !important;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.no-margin {
  margin-bottom: 0px;
}

.profile-image {
  width: 300px;
  height: 300px;
  border-radius: 50%;
  padding: 1rem;
  position: absolute;
  z-index: 1;
  object-fit: cover !important;
}

@media (max-width: 768px) {
  .profile-image {
    display: none;
  }

  .stars {
    padding-top: 0px;
  }
}

.far, .fa {
  font-size: 1.5rem;
}

.star-selector >>> .fa-star {
  font-size: 2rem;
}

.default-banner-image {
  background-color: #717171;
}

.underline {
  border-bottom: 4px solid #FEEDAA !important;
}
</style>



// WEBPACK FOOTER //
// src/components/business/Business.vue